module.exports = __webpack_public_path__ + "img/white.965f48fd.png";